import { __decorate } from "tslib";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import DateMixin from '@/helpers/mixins/DateMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import { requiredProperty } from '@/helpers/mixins/LocalizationHelper';
import WindowSizeListener from '@/helpers/vue_mixins/v3/WindowSizeListenerMixin';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import RadioBoxGroup from '@/views/v3/RadioBoxGroup.vue';
import ActionButton from '@/components/action_button/Index.vue';
import AdSets from '@/plugins/graphql/queries/v3/ad-sets.gql';
import MetaCountries from '@/plugins/graphql/queries/v3/meta-countries.gql';
import MetaRegions from '@/plugins/graphql/queries/v3/meta-regions.gql';
import MetaCities from '@/plugins/graphql/queries/v3/meta-cities.gql';
import LinkButton from '@/components/link_button/Index.vue';
import NumericInput from '@/components/v2/NumericInput.vue';
import BaseDatePicker from '@/components/datepicker/Index.vue';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import { debounce } from "lodash";
import { required, requiredIf, decimal } from 'vuelidate/lib/validators';
import moment from 'moment';
import CreateNewAdSet from '@/plugins/graphql/mutations/ads_manager/create-ad-set.gql';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import Modal from '@/components/v3/Modal.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import CustomAudiences from '@/plugins/graphql/queries/v3/custom-audiences.gql';
import LookalikeAudiences from '@/plugins/graphql/queries/v3/lookalike-audiences.gql';
import AppSegmentations from '@/plugins/graphql/queries/v2/app-segmentations-basic.gql';
import { AppSegmentationBasicModel } from '@/helpers/entities/models/AppSegmentationBasicModel';
import CreateAudience from '@/plugins/graphql/mutations/ads_manager/create-audience.gql';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
import { ECOMMERCE_B2C, SHOPIFY } from '@/helpers/constants/Bundles';
import AdPixels from '@/plugins/graphql/queries/v3/ad-pixels.gql';
let ComponentName = class ComponentName extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, WindowSizeListener, FormValidationsMixin, Mixins(FormMixin, DateMixin, AlertMixin)) {
    constructor() {
        super(...arguments);
        this.isActive = true;
        this.useAudience = false;
        this.createNewAudience = false;
        this.queryLoading = false;
        this.metaCountries = [];
        this.metaRegions = [];
        this.metaCities = [];
        this.adSets = [];
        this.customAudiences = [];
        this.lookalikeAudiences = [];
        this.appSegments = [];
        this.adPixels = [];
        this.adPixelEvents = [
            { name: 'Purchase', value: 'PURCHASE' },
            { name: 'Initiate Checkout', value: 'INITIATED_CHECKOUT' },
            { name: 'Add To Cart', value: 'ADD_TO_CART' },
            { name: 'View Content', value: 'CONTENT_VIEW' },
        ];
        this.selectedOption = 1;
        this.selectedCountry = '';
        this.selectedRegions = [];
        this.selectedCity = '';
        this.regionKeyword = '';
        this.cityKeyword = '';
        this.createLookalike = false;
        this.options = [
            { value: 'Select Existing\nAd Set', index: 1 },
            { value: 'Create New\nAd Set', index: 2 },
        ];
        this.genderOptions = [
            { value: null, text: 'All' },
            { value: 1, text: 'Male' },
            { value: 2, text: 'Female' },
        ];
        this.deviceOptions = [
            { value: null, text: 'All Device' },
            { value: 'mobile', text: 'Mobile' },
            { value: 'desktop', text: 'Desktops' },
        ];
        this.platformOptions = [
            { value: 'facebook', text: 'Facebook' },
            { value: 'instagram', text: 'Instagram' },
            { value: 'messenger', text: 'Messenger' },
        ];
        this.budgetTypeOptions = [
            { value: 'lifetime_budget', text: 'Lifetime Budget' },
            { value: 'daily_budget', text: 'Daily Budget' },
        ];
        this.form = {
            adSet: null,
            name: '',
            goal: 'CONVERSATIONS',
            gender: null,
            minAge: '18',
            maxAge: '65+',
            country: null,
            regions: [],
            cities: [],
            device: null,
            platforms: [
                { value: 'facebook', text: 'Facebook' },
                { value: 'instagram', text: 'Instagram' },
                { value: 'messenger', text: 'Messenger' },
            ],
            budgetType: 'lifetime_budget',
            budget: 0,
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
            customAudiences: [],
            pixelId: null,
            conversionEvent: { name: 'Purchase', value: 'PURCHASE' },
        };
        this.audience = {
            customName: '',
            lookalikeName: '',
            customAudiences: null,
            appSegmentations: [],
        };
        this.sending = false;
        // eslint-disable-next-line func-names
        this.cityChanged = debounce(function (event, index) {
            const searchInput = document.querySelector(`#search-city-${index}`);
            this.cityKeyword = event.target.value;
            this.waitForQueryToFinish(searchInput).then(() => {
                this.focusElement(searchInput);
            });
        }, 900);
        this.searchInputSegments = [];
        // eslint-disable-next-line func-names
        this.regionChanged = debounce(async function (event, index) {
            const searchInput = document.querySelector(`#search-region-${index}`);
            this.regionKeyword = event.target.value;
            this.waitForQueryToFinish(searchInput).then(() => {
                this.focusElement(searchInput);
            });
        }, 900);
        this.customAudienceKeyword = '';
        this.lookalikeAudienceKeyword = '';
        this.budgetError = '';
        this.showBudgetError = false;
        this.selectedTab = 'Audience';
        this.audienceTab = 'Custom Audience';
        this.creatingAudience = false;
    }
    get containerHeight() {
        if (this.selectedOption === 1) {
            return {
                height: `${this.window.height * 0.6}px`,
            };
        }
        return {};
    }
    addRegion() {
        const vm = this;
        vm.form.regions.push(null);
    }
    removeRegion(index) {
        this.form.regions.splice(index, 1);
        if (this.form.cities[index]) {
            this.form.cities.splice(index, 1);
        }
    }
    get filteredRegions() {
        const vm = this;
        const formRegions = vm.form.regions || [];
        const selectedRegions = formRegions.flat(Infinity).map((region) => region?.key);
        return vm.metaRegions.filter((region) => !selectedRegions.includes(region?.key));
    }
    get createAudienceHeader() {
        if (this.audienceTab === 'Lookalike Audience') {
            return 'Create New Lookalike Audience';
        }
        return 'Create New Custom Audience';
    }
    get createAudienceName() {
        if (this.audienceTab === 'Lookalike Audience') {
            return 'Lookalike Audience Name';
        }
        return 'Custom Audience Name';
    }
    get allQueriesLoading() {
        return (this.$apollo.queries.adSets.loading ||
            this.$apollo.queries.metaCountries.loading ||
            this.$apollo.queries.metaRegions.loading ||
            this.$apollo.queries.metaCities.loading ||
            this.$apollo.queries.customAudiences.loading ||
            this.$apollo.queries.lookalikeAudiences.loading ||
            this.$apollo.queries.appSegments.loading ||
            this.$apollo.queries.adPixels.loading);
    }
    toggleConfirmation() {
        // this.selectedNotification = uuid;
        // this.$emit('selectDeleteUuid');
        this.showConfirmationDialog();
    }
    uponConfirm() {
        this.hideConfirmationDialog();
        this.$router.push({ name: 'ads-manager' });
    }
    get adDays() {
        const start = moment(this.form.startDate, 'YYYY-MM-DD'); // Parse startDate as a Moment object
        const end = moment(this.form.endDate, 'YYYY-MM-DD'); // Parse endDate as a Moment object
        const diffDays = end.diff(start, 'days'); // Get the difference in days
        return diffDays === 1 ? `${diffDays} day` : `${diffDays} days`; // Singular/plural
    }
    tabBuilder() {
        const commonProps = {
            orangeTheme: true,
            flat: true,
            capitalized: true,
        };
        return [
            {
                ...commonProps,
                id: 'audience',
                label: 'Audience',
            },
            {
                ...commonProps,
                id: 'budget',
                label: 'Budget',
            },
        ];
    }
    audienceTabs() {
        const commonProps = {
            orangeTheme: true,
            flat: true,
            capitalized: true,
        };
        return [
            {
                ...commonProps,
                id: 'custom',
                label: 'Custom Audience',
            },
            {
                ...commonProps,
                id: 'lokalike',
                label: 'Lookalike Audience',
            },
        ];
    }
    get goals() {
        if (this.adCampaignObjective === 'OUTCOME_SALES') {
            return [
                { text: 'Maximize number of conversations', value: 'CONVERSATIONS' },
                { text: 'Maximize number of conversions', value: 'OFFSITE_CONVERSIONS' },
            ];
        }
        return [{ text: 'Maximize number of conversations', value: 'CONVERSATIONS' }];
    }
    get tooltipText() {
        const vm = this;
        if (vm.form.goal === 'OFFSITE_CONVERSIONS') {
            return "We'll optimize ad delivery to reach the right audience and help you achieve the highest number of website conversions.";
        }
        return "We'll prioritize showing your ads to people who are most likely to start a conversation with you through messaging.";
    }
    audienceSelection() {
        if (this.audienceTab === 'Lookalike Audience') {
            return this.lookalikeAudiences;
        }
        return this.customAudiences;
    }
    get isB2cBundle() {
        return (this.$route.params.key === Bundle.Ecommerce || this.$props?.serviceBundle === ECOMMERCE_B2C);
    }
    get isShopifyBundle() {
        return this.$route.params.key === Bundle.Shopify || this.$props?.serviceBundle === SHOPIFY;
    }
    get isInsuranceBundle() {
        return this.$route.params.key === Bundle.Insurance;
    }
    async proceedToNext() {
        this.$v.form.$touch();
        if (!this.$v.form.$invalid) {
            if (this.selectedOption === 2) {
                this.sending = true;
                const mutation = () => this.createAdSet();
                await mutation()
                    .then(async ({ data }) => {
                    this.setAdSetId(data.createAdSet.adSetId);
                    this.setAdSetGoal(this.form.goal);
                    this.sending = false;
                    this.$emit('proceedToNext');
                })
                    .catch(() => {
                    this.sending = false;
                });
            }
            else {
                this.$emit('proceedToNext');
            }
        }
    }
    resetCityKeyword(event, index) {
        if (this.searchInputSegments[index]) {
            this.$set(this.searchInputSegments, index, '');
        }
    }
    focusElement(searchInput) {
        if (searchInput) {
            const inputElement = searchInput;
            inputElement.focus();
        }
    }
    clearRegionsCities() {
        this.form.regions = [];
        this.form.cities = [];
    }
    checkExistingRegion(event, index) {
        const regionKey = event.key;
        const regionCount = this.form.regions.flat(Infinity).reduce((acc, region) => {
            acc[region.key] = (acc[region.key] || 0) + 1;
            return acc;
        }, {});
        if (regionCount[regionKey] > 1) {
            console.warn(`Region ${regionKey} is selected more than once!`);
            this.form.regions.pop();
        }
        else {
            this.form.cities.splice(index, 1);
        }
    }
    countryChanged() {
        const vm = this;
        vm.$v.form.country.$touch();
    }
    customAudienceChanged(event) {
        const vm = this;
        vm.$v.audience.customAudiences.$touch();
        vm.customAudienceKeyword = event.target.value;
    }
    lookalikeAudienceChanged(event) {
        const vm = this;
        vm.$v.audience.lookalikeAudienceChanged.$touch();
        vm.lookalikeAudienceKeyword = event.target.value;
    }
    onAdSetChange() {
        const vm = this;
        this.setAdSetId(vm.form.adSet?.id);
        this.setAdSetGoal(vm.form.adSet?.optimizationGoal);
    }
    onCampaignChange() {
        if (this.adCampaignObjective === 'OUTCOME_SALES') {
            this.form.goal = 'OFFSITE_CONVERSIONS';
        }
    }
    onAdSetGoalChange() {
        const vm = this;
        this.setAdSetGoal(vm.form.goal);
    }
    onCountryChange() {
        const vm = this;
        this.selectedCountry = vm.form.country.name;
    }
    onRegionChange() {
        const vm = this;
        vm.$v.form.$touch();
        vm.selectedRegions = vm.form.regions.map((region) => region?.name);
    }
    onStartDateChange() {
        const vm = this;
        if (vm.form.startDate >= vm.form.endDate) {
            vm.form.endDate = moment(vm.form.startDate).add(1, 'days').format('YYYY-MM-DD');
        }
    }
    onBudgetChange() {
        if (this.showBudgetError) {
            this.showBudgetError = false;
        }
    }
    get isDesktop() {
        const vm = this;
        return vm.form.device === 'desktop';
    }
    onDeviceChange(newValue, oldValue) {
        if ((oldValue === 'mobile' || oldValue === null) && newValue === 'desktop') {
            this.form.platforms = [];
        }
        if ((newValue === 'mobile' || newValue === null) && oldValue === 'desktop') {
            this.form.platforms = [
                { value: 'facebook', text: 'Facebook' },
                { value: 'instagram', text: 'Instagram' },
                { value: 'messenger', text: 'Messenger' },
            ];
        }
    }
    onAudienceTabChange() {
        const vm = this;
        vm.audience.appSegmentations = [];
        vm.audience.customAudiences = null;
        vm.form.customAudiences = [];
    }
    onSelectedOptionChange() {
        if (this.selectedOption === 2) {
            if (this.adCampaignObjective === 'OUTCOME_SALES') {
                this.form.goal = 'OFFSITE_CONVERSIONS';
            }
            if (this.adCampaignObjective === 'OFFSITE_CONVERSIONS') {
                this.form.goal = 'CONVERSATIONS';
            }
        }
    }
    hasKeyAndName(obj) {
        if (!obj || (obj?.name && obj?.key) || this.selectedOption === 1) {
            return true;
        }
        return false;
    }
    valuedHasKeyAndName(obj) {
        if ((obj?.name && obj?.key) || this.selectedOption === 1) {
            return true;
        }
        return false;
    }
    hasId(obj) {
        if (obj?.id || this.selectedOption === 2) {
            return true;
        }
        return false;
    }
    hasAudienceId(obj) {
        if (obj?.id || this.audienceTab === 'Custom Audience') {
            return true;
        }
        return false;
    }
    hasUuid(obj) {
        return obj.every((item) => item?.uuid);
    }
    get idErrors() {
        const errors = [];
        if (!this.$v.form.adSet.$dirty) {
            return errors;
        }
        if (!this.$v.form.adSet.required) {
            const msg = requiredProperty('Ad Set');
            errors.push(msg);
        }
        if (!this.$v.form.adSet.invalidId) {
            const msg = 'Please Select an Ad Set From The List';
            errors.push(msg);
        }
        return errors;
    }
    get idCustomErrors() {
        const errors = [];
        if (!this.$v.audience.appSegmentations.$dirty) {
            return errors;
        }
        if (!this.$v.audience.appSegmentations.required) {
            const msg = requiredProperty('Customer Segment');
            errors.push(msg);
        }
        if (!this.$v.audience.appSegmentations.invalidId) {
            const msg = 'Please Select a Customer Segment From The List';
            errors.push(msg);
        }
        return errors;
    }
    get idlookalikeErrors() {
        const errors = [];
        if (!this.$v.audience.customAudiences.$dirty) {
            return errors;
        }
        if (!this.$v.audience.customAudiences.required) {
            const msg = requiredProperty('Custom Audience');
            errors.push(msg);
        }
        if (!this.$v.audience.customAudiences.invalidId) {
            const msg = 'Please Select a Custom Audience From The List';
            errors.push(msg);
        }
        return errors;
    }
    get countryErrors() {
        const errors = [];
        if (!this.$v.form.country.$dirty) {
            return errors;
        }
        if (!this.$v.form.country.required) {
            const msg = requiredProperty('Country');
            errors.push(msg);
        }
        if (!this.$v.form.country.invalidCountry) {
            const msg = 'Please Select a Country From The List';
            errors.push(msg);
        }
        return errors;
    }
    regionErrors(v) {
        const errors = [];
        if (!v.$dirty) {
            return errors;
        }
        if (!this.valuedHasKeyAndName(v.$model) && this.formRegionLegnthChecker) {
            const msg = 'Please Select a Region From The List';
            errors.push(msg);
        }
        return errors;
    }
    get formRegionLegnthChecker() {
        return this.form.regions.length > 0;
    }
    cityErrors(cities) {
        const errors = [];
        if (cities) {
            cities.forEach((city) => {
                // Invoke v-list-group toggle() function to close nested menus
                if (!this.hasKeyAndName(city)) {
                    const msg = 'Please Select a City From The List';
                    errors.push(msg);
                }
            });
        }
        return errors;
    }
    get platformOptionsErrors() {
        const errors = [];
        // Ensure the validation object is dirty (i.e., has been interacted with)
        if (!this.$v.form.platforms?.$dirty) {
            return errors;
        }
        // Check if the required validation has failed
        if (!this.$v.form.platforms?.required) {
            const msg = requiredProperty('Platforms');
            errors.push(msg);
        }
        return errors;
    }
    generateAgeOptions(age) {
        const ages = Array.from({ length: 64 - 18 + 1 }, (v, i) => (i + 18).toString());
        if (age === 'min') {
            ages.push('65+');
            return ages;
        }
        ages.push('65+');
        return ages;
    }
    checkSelectedTab(label) {
        if (this.selectedTab === label) {
            return true;
        }
        return false;
    }
    checkSelectedAudienceTab(label) {
        if (this.audienceTab === label) {
            return true;
        }
        return false;
    }
    async createAdSet() {
        const vm = this;
        const country = vm.form.country.key;
        const cities = vm.form.cities.flat(Infinity).map((city) => city.key);
        const regions = vm.form.regions.flat(Infinity).map((region) => region.key);
        const customAudienceIds = vm.form.customAudiences.map((audience) => audience.id);
        const platforms = vm.form.platforms.map((platform) => {
            return platform.value;
        });
        const variables = {
            input: {
                appUuid: vm.appUUID,
                name: vm.form.name,
                goal: vm.form.goal,
                country,
                regions,
                cities,
                gender: vm.form.gender,
                deviceTypes: vm.form.device,
                minAge: vm.form.minAge,
                maxAge: vm.form.maxAge,
                platforms,
                budgetType: vm.form.budgetType,
                budget: vm.form.budget,
                startDate: vm.form.startDate,
                endDate: vm.form.endDate,
                adCampaignId: vm.adCampaignId,
                adAccountId: vm.adAccountId,
                customAudienceIds,
                campaignObjective: this.adCampaignObjective,
                pixelId: vm.form.pixelId?.id,
                conversionEvent: vm.form.conversionEvent?.value,
            },
        };
        return this.$apollo
            .mutate({
            mutation: CreateNewAdSet,
            variables,
        })
            .catch((e) => {
            this.errorNotification(e.message);
            const errorParts = e.message.split('::');
            if (e.message.includes('budget')) {
                this.budgetError = errorParts
                    .filter((part) => part.toLowerCase().includes('budget'))
                    .join(', ');
                this.showBudgetError = true;
            }
        });
    }
    get regionLabel() {
        if (this.form.regions) {
            return 'Region';
        }
        return 'Search And Select Region';
    }
    get cityLabel() {
        if (this.form.cities) {
            return 'City';
        }
        return 'Search And Select City';
    }
    async mounted() {
        await this.$apollo.queries.adSets.refetch().then(async () => {
            if (this.adSetId) {
                const selectedAdSet = this.adSets.filter((adSet) => {
                    return adSet.id === this.adSetId;
                });
                [this.form.adSet] = selectedAdSet;
            }
        });
    }
    async createAudience() {
        const vm = this;
        this.$v.audience.$touch();
        const customerSegmentUuids = vm.audience.appSegmentations.map((segment) => segment.uuid);
        if (!this.$v.audience.$invalid) {
            vm.creatingAudience = true;
            const variables = {
                input: {
                    appUuid: vm.appUUID,
                    createAction: vm.audienceTab,
                    audienceName: vm.audience.customName,
                    lookalikeName: vm.audience.lookalikeName,
                    adAccountId: vm.adAccountId,
                    createLookalike: vm.createLookalike,
                    customAudienceId: vm.audience.customAudiences?.id,
                    customerSegmentUuids,
                },
            };
            await this.$apollo
                .mutate({
                mutation: CreateAudience,
                variables,
            })
                .then(() => {
                this.successNotification('Audience Successfully Created');
                vm.createNewAudience = false;
            })
                .catch((e) => {
                this.errorNotification(e.message);
            })
                .finally(() => {
                vm.creatingAudience = false;
                this.$apollo.queries.customAudiences.refetch();
                this.$apollo.queries.lookalikeAudiences.refetch();
            });
        }
    }
};
__decorate([
    Mutation('setAdSetId')
], ComponentName.prototype, "setAdSetId", void 0);
__decorate([
    Mutation('setAdSetGoal')
], ComponentName.prototype, "setAdSetGoal", void 0);
__decorate([
    Mutation('showConfirmationDialog')
], ComponentName.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], ComponentName.prototype, "hideConfirmationDialog", void 0);
__decorate([
    Getter('adCampaignId')
], ComponentName.prototype, "adCampaignId", void 0);
__decorate([
    Getter('adAccountId')
], ComponentName.prototype, "adAccountId", void 0);
__decorate([
    Getter('adSetId')
], ComponentName.prototype, "adSetId", void 0);
__decorate([
    Getter('adCampaignObjective')
], ComponentName.prototype, "adCampaignObjective", void 0);
__decorate([
    Watch('form.adSet')
], ComponentName.prototype, "onAdSetChange", null);
__decorate([
    Watch('adCampaignObjective')
], ComponentName.prototype, "onCampaignChange", null);
__decorate([
    Watch('form.goal')
], ComponentName.prototype, "onAdSetGoalChange", null);
__decorate([
    Watch('form.country.name')
], ComponentName.prototype, "onCountryChange", null);
__decorate([
    Watch('form.regions', { deep: true })
], ComponentName.prototype, "onRegionChange", null);
__decorate([
    Watch('form.startDate')
], ComponentName.prototype, "onStartDateChange", null);
__decorate([
    Watch('form.budget')
], ComponentName.prototype, "onBudgetChange", null);
__decorate([
    Watch('form.device')
], ComponentName.prototype, "onDeviceChange", null);
__decorate([
    Watch('audienceTab')
], ComponentName.prototype, "onAudienceTabChange", null);
__decorate([
    Watch('selectedOption')
], ComponentName.prototype, "onSelectedOptionChange", null);
ComponentName = __decorate([
    Component({
        components: {
            BaseTextField,
            RadioBoxGroup,
            ActionButton,
            LinkButton,
            NumericInput,
            BaseDatePicker,
            ConfirmationDialog,
            Modal,
            FormHeader,
            BaseOverlayLoader,
        },
        apollo: {
            // Your component apollo queries here
            adSets: {
                query: AdSets,
                variables() {
                    this.queryLoading = true;
                    return {
                        appUuid: this.$route.params.appUUID,
                        adCampaignId: this.adCampaignId,
                        objective: this.adCampaignObjective,
                    };
                },
                update(data) {
                    if (!data?.adSets?.length) {
                        this.options = [{ value: 'Create New\nAd Set', index: 2 }];
                        this.selectedOption = 2;
                    }
                    else {
                        this.options = [
                            { value: 'Select Existing\nAd Set', index: 1 },
                            { value: 'Create New\nAd Set', index: 2 },
                        ];
                        this.selectedOption = 1;
                    }
                    this.queryLoading = false;
                    return data.adSets;
                },
            },
            metaCountries: {
                query: MetaCountries,
                variables() {
                    this.queryLoading = true;
                    return {
                        appUuid: this.$route.params.appUUID,
                    };
                },
                update(data) {
                    const PH = data.metaCountries.find((country) => country.key === 'PH');
                    this.form.country = PH;
                    this.queryLoading = false;
                    return data.metaCountries;
                },
            },
            metaRegions: {
                query: MetaRegions,
                variables() {
                    this.queryLoading = true;
                    return {
                        appUuid: this.$route.params.appUUID,
                        country: this.selectedCountry,
                        keyword: this.regionKeyword,
                    };
                },
                update(data) {
                    this.queryLoading = false;
                    return data.metaRegions;
                },
            },
            metaCities: {
                query: MetaCities,
                variables() {
                    this.queryLoading = true;
                    return {
                        appUuid: this.$route.params.appUUID,
                        country: this.selectedCountry,
                        regions: this.selectedRegions,
                        keyword: this.cityKeyword,
                    };
                },
                update(data) {
                    this.queryLoading = false;
                    return data.metaCities;
                },
                skip() {
                    return !this.selectedCountry && !this.selectedRegions;
                },
            },
            customAudiences: {
                query: CustomAudiences,
                variables() {
                    this.queryLoading = true;
                    return {
                        appUuid: this.$route.params.appUUID,
                        adAccountId: this.adAccountId,
                        keyword: this.customAudienceKeyword,
                    };
                },
                update(data) {
                    this.queryLoading = false;
                    return data.customAudiences;
                },
            },
            lookalikeAudiences: {
                query: LookalikeAudiences,
                variables() {
                    this.queryLoading = true;
                    return {
                        appUuid: this.$route.params.appUUID,
                        adAccountId: this.adAccountId,
                        keyword: this.lookalikeAudienceKeyword,
                    };
                },
                update(data) {
                    this.queryLoading = false;
                    return data.lookalikeAudiences;
                },
            },
            appSegments: {
                query: AppSegmentations,
                variables() {
                    this.queryLoading = true;
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    const node = (segment) => {
                        return new AppSegmentationBasicModel(segment.node);
                    };
                    this.queryLoading = false;
                    return data.appSegmentations.edges.map(node);
                },
            },
            adPixels: {
                query: AdPixels,
                variables() {
                    this.queryLoading = true;
                    return {
                        appUuid: this.appUUID,
                        adAccountId: this.adAccountId,
                    };
                },
                update(data) {
                    this.queryLoading = false;
                    return data.adPixels;
                },
            },
        },
        validations() {
            const vm = this;
            const selectAdSet = () => vm.selectedOption === 1;
            const newAdSet = () => vm.selectedOption === 2;
            const allGender = () => vm.form.gender?.text === 'All';
            const allDevice = () => vm.form.device?.text === 'All Device';
            const newAudience = () => vm.createNewAudience === true;
            const newCustomAudience = () => vm.audienceTab === 'Custom Audience';
            const newLookalikeAudience = () => vm.audienceTab === 'Lookalike Audience';
            const isConversions = () => vm.adCampaignObjective === 'OFFSITE_CONVERSIONS' && vm.selectedOption === 2;
            const isNotDesktop = () => vm.form.device !== 'desktop';
            const hasRegions = () => vm.formRegionLegnthChecker;
            const validations = {
                form: {
                    adSet: {
                        required: requiredIf(selectAdSet),
                        invalidId() {
                            const { adSet } = this.form;
                            return vm.hasId(adSet);
                        },
                    },
                    name: {
                        required: requiredIf(newAdSet),
                    },
                    goal: {
                        required: requiredIf(newAdSet),
                    },
                    gender: {
                        required: requiredIf(newAdSet && allGender),
                    },
                    minAge: {
                        required: requiredIf(newAdSet),
                    },
                    maxAge: {
                        required: requiredIf(newAdSet),
                    },
                    country: {
                        required: requiredIf(newAdSet),
                        invalidCountry() {
                            const { country } = this.form;
                            return vm.hasKeyAndName(country);
                        },
                    },
                    regions: {
                        $each: {
                            name: { required },
                            key: { required },
                        },
                    },
                    cities: {
                        $each: {
                            $each: {
                                name: { required },
                                key: { required },
                            },
                        },
                    },
                    device: {
                        required: requiredIf(newAdSet && allDevice),
                    },
                    platforms: {
                        required: requiredIf(isNotDesktop),
                    },
                    pixelId: {
                        required: requiredIf(isConversions),
                    },
                    conversionEvent: {
                        required: requiredIf(isConversions),
                    },
                    budgetType: {
                        required: requiredIf(newAdSet),
                    },
                    budget: {
                        required: requiredIf(newAdSet),
                        decimal,
                    },
                    startDate: {
                        required: requiredIf(newAdSet),
                    },
                    endDate: {
                        required: requiredIf(newAdSet),
                    },
                    customAudiences: {
                        required: requiredIf(newAudience),
                    },
                },
                audience: {
                    customName: {
                        required: requiredIf(newAudience && newCustomAudience),
                    },
                    lookalikeName: {
                        required: requiredIf(newAudience && newLookalikeAudience),
                    },
                    appSegmentations: {
                        required: requiredIf(newAudience && newCustomAudience),
                        invalidId() {
                            const { appSegmentations } = this.audience;
                            return vm.hasUuid(appSegmentations);
                        },
                    },
                    customAudiences: {
                        required: requiredIf(newAudience && newLookalikeAudience),
                        invalidId() {
                            const { customAudiences } = this.audience;
                            return vm.hasAudienceId(customAudiences);
                        },
                    },
                },
            };
            return validations;
        },
        computed: {
            filteredCities() {
                return (index) => {
                    const region = this.form.regions[index]?.name;
                    return this.metaCities.filter((city) => city.region === region);
                };
            },
        },
        methods: {
            waitForQueryToFinish(searchInput) {
                return new Promise((resolve) => {
                    const checkLoading = () => {
                        if (Object.values(this.$apollo.queries).every((query) => !query.loading)) {
                            resolve(); // Call resolve when all queries are done
                        }
                        else {
                            setTimeout(checkLoading, 200); // Keep checking
                        }
                    };
                    checkLoading();
                });
            },
        },
    })
], ComponentName);
export default ComponentName;
